import request from '@/utils/request'

let SchoolApi = {

  /*培训学校列表*/
  list(data) {
    return request._post('/shop/plus.school.Index/index', data);
},
/*添加培训学校*/
add(data) {
    return request._post('/shop/plus.school.Index/add', data);
},
/*修改培训学校*/
edit(data) {
    return request._post('/shop/plus.school.Index/edit', data);
},
/*删除培训学校*/
del(data) {
    return request._post('/shop/plus.school.Index/del', data);
},
/*培训学校详情*/
detail(data) {
  return request._post('/shop/plus.school.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.school.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.school.Setting/getSetting', data, errorback);
    },
}
export default SchoolApi;



// WEBPACK FOOTER //
// ./src/api/school.js